'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDigitGroupDelimiter;
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function getDigitGroupDelimiter(locale) {
  var number = 1000;
  return number.toLocaleString(locale).replace(/[01]/g, '') || ','; // we need || "," since SAFARI does not work correctly
}